// English translations
export const en = {
  title: 'HandinCap',
  subtitle: 'Just a ScoreCard',
  create: 'Create New Game',
  courseTitle: 'Course Setup',
  autoMode: 'Auto Search',
  manualMode: 'Manual Input',
  searchPlaceholder: 'Search course name...',
  selectCourse: 'Select Course',
  gameType: 'Game Type',
  setPar: 'Set PAR Values',
  confirmCourse: 'Confirm',
  playerTitle: 'Player Setup',
  players: 'Players',
  player1: 'Player 1',
  player2: 'Player 2',
  player3: 'Player 3',
  player4: 'Player 4',
  player5: 'Player 5',
  player6: 'Player 6',
  player7: 'Player 7',
  player8: 'Player 8',
  enterName: 'Enter name',
  gameMode: 'Game Mode',
  matchPlay: 'Match Play',
  win123: 'Win123',
  skins: 'Skins',
  baccarat: 'Baccarat',
  stake: 'Stake',
  prizePool: 'Prize Pool',
  penaltyPot: 'Pot',
  optional: 'Optional',
  enterStake: 'Enter amount (optional)',
  handicap: 'Handicap',
  handicapSettings: 'Handicap Settings',
  off: 'Off',
  on: 'On',
  back: 'Back',
  start: 'Start Game',
  hole: 'Hole',
  par: 'PAR',
  nextHole: 'Confirm & Next',
  currentMoney: 'Live Standings',
  poolBalance: 'Pool Balance',
  holeTied: 'Hole Tied',
  poolGrows: 'Next hole pool',
  skinsWinner: '{player} wins the Skin!',
  holeSettlement: 'Hole Settlement',
  netScore: 'Net',
  rank: 'Rank {n}',
  winner: 'Winner',
  resume: 'Resume Game',
  finishRound: 'Confirm & Finish',
  kaki: 'Kaki',
  kakiDeleteConfirm: 'Delete this Kaki?',
  confirmHoleScore: 'Confirm Hole {hole} Scores',
  holeScoresSummary: 'Player Scores:',
  cancel: 'Cancel',
  yes: 'Yes',
  confirm: 'Confirm',
  switchLang: 'Language',
  noStake: 'Please enter stake amount',
  atLeast2: 'Please enter at least 2 players',
  gameOver: 'Game Over!',
  backToHome: 'Back to Home',
  out: 'OUT',
  in: 'IN',
  total: 'Tot',
  totalScore: 'Total Score',
  standardPar: 'Par',
  finalSettlement: 'Final Settlement',
  noScoreData: 'No scores recorded yet',
  f9: 'Front 9',
  b9: 'Back 9',
  f18: 'Front 18',
  b18: 'Back 18',
  f9Desc: 'Holes 1-9',
  b9Desc: 'Holes 10-18',
  f18Desc: 'Standard 1-18',
  b18Desc: '10-18, 1-9',
  duplicateNames: 'Player names must be unique',
  screenshotHint: 'We recommend taking a screenshot to save your scores',
  totalLoss: 'Total',
  totalPar: 'PAR',
  noCourses: 'No courses found',
  trySearch: 'Try different keywords',
  front9: 'Front 9',
  back9: 'Back 9',
  eagle: 'Eagle',
  birdie: 'Birdie',
  parLabel: 'Par',
  bogey: 'Bogey',
  doubleplus: 'Double+',
  selectHoleToEdit: 'Select Hole to Edit',
  holeJumpTitle: 'Jump to Hole',
  holeJumpReturnToast: '{n} holes left — back to hole {hole}',
  editHole: 'Edit Hole',
  save: 'Save',
  scoreUpdated: 'Scores updated, money recalculated',
  // Game mode descriptions
  matchPlayDesc: 'Lowest net wins, losers pay stake',
  win123Desc: 'Ranked penalty to pool, UP for risk/reward',
  skinsDesc: 'All-in each hole, sole low takes pot',
  baccaratDesc: 'Head-to-head matchups, UP multiplies stake',
  // Report related
  reportTitle: "'s Report",
  scoreDistribution: 'Score Distribution',
  puttingAnalysis: 'Putting Analysis',
  totalPutts: 'Total Putts',
  avgPerHole: 'Avg/Hole',
  onePutt: 'One-Putts',
  threePutts: '3-Putts+',
  holes: ' holes',
  penaltyStats: 'Penalty Stats',
  waterHazard: 'Water',
  stats: ' Stats',
  attempts: ' Attempts',
  times: '',
  holeByHole: 'Hole by Hole',
  viewFullDetail: 'View Full Detail',
  fullDetail: 'Full Detail',
  strokes: ' strokes',
  putt: 'Putt',
  water: 'Water',
  clickNameToView: 'Tap name to view details',
  // Putts confirmation
  confirmPutts: 'Confirm Putts',
  zeroPuttsWarning: 'The following players have 0 putts:',
  puttsScore: 'Score',
  puttsStrokes: '',
  puttsPutts: 'Putts',
  puttsTip: "Tip: Unless it's a chip-in, putts are usually not 0",
  puttsGoBack: 'Go Back',
  puttsConfirm: 'Confirm',
  // Multiplayer
  mpMultiplayer: 'Multiplayer',
  mpSync: 'Multiplayer Sync',
  mpCodePlaceholder: 'CODE',
  mpEnter6Digit: 'Enter 4-digit code',
  mpJoin: 'Join',
  mpPointQr: 'Point at QR code',
  mpQrLoadFail: 'QR lib load failed',
  mpLinkCopied: 'Link copied!',
  mpCopyLink: 'Copy Link',
  mpShareLink: 'Share',
  startSolo: 'Start Solo',
  mpJumbo: 'Jumbo',
  mpCreateRoom: 'Create Room',
  mpWaitingPartner: 'Waiting for Partner',
  mpWaitingStart: 'Waiting to Start',
  mpRoomCode: 'Room Code',
  mpCopied: 'Copied!',
  mpCopyCode: 'Copy Code',
  mpScanToJoin: 'Scan to join',
  mpGameInfo: 'Game Info',
  mpCourse: 'Course',
  mpMode: 'Mode',
  mpStake: 'Stake',
  mpRoom: 'Room',
  mpPlayerAssignment: 'Player Assignment',
  mpMine: 'Mine',
  mpPartner: 'Partner',
  mpUnclaimed: 'Unclaimed',
  mpConnected: 'Connected',
  mpError: 'Error',
  mpConnecting: 'Connecting...',
  mpStartGame: 'Start Game',
  mpWaitingCreator: 'Waiting for Creator to start the game...',
  mpClaimTitle: 'Claim Your Players',
  mpClaimDesc: 'Select players you will score for',
  mpSelectOne: 'Select at least one player',
  mpConfirmClaim: 'Confirm Claim',
  mpConfirmSubmit: 'Confirm',
  mpWaiting: 'Waiting...',
  mpConfirmFinish: 'Confirm & Finish',
  mpConfirmNext: 'Confirm & Next',
  mpAdvancedStats: 'Advanced Stats Mode',
  mpHolesLabel: 'Holes',
  // ===== Additional UI keys =====
  hcpLabel: 'HCP',
  hideInfo: 'Hide',
  learnMore: 'Learn more',
  close: 'Close',
  clearRecent: 'Clear',
  recentCourses: 'Recent Courses',
  endGame: 'End',
  shareRoundReport: 'Share Round Report',
  allDataCleared: 'All game data will be cleared',
  endGameConfirm: 'End the game now?\nIncomplete holes will not be counted',
  holeLabel: 'Hole {n}',
  holeLabelShort: 'H{n}',
  cameraAccessDenied: 'Camera access denied',
  generateLinkFailed: 'Failed to generate link',
  copyFailed: 'Copy failed',
  retracted: 'Retracted. You can edit scores now.',
  matchPlayBubble: 'Lowest net score wins each hole. Tied? No one pays.',
  win123Bubble: 'Ranked by net score. Lower rank = bigger penalty. UP to raise stakes.',
  skinsBubble: 'Lowest score alone takes the pot. Tied? Rolls to next hole.',
  baccaratBubble: '4 players, 6 matchups. Call UP to raise your bet.',
  mpSyncBubble: 'You score your players, your friend scores theirs. Scores sync automatically.',
  hcpBubble: 'Handicap (0-36): Levels the playing field. Strokes are auto-distributed across holes by course difficulty.',
  undoEdit: 'Undo & Edit',
  waitingProceed: 'Waiting {badge} to proceed...',
  voiceWithHcp: '{player}, {on} on, {putt} {puttWord}, {handicap} handicap.',
  voiceNoHcp: '{player}, {on} on, {putt} {puttWord}.',
  voiceHoleIntro: 'This is hole {hole}, par {par}, index {index}.',
  voiceHoleIntroNoIdx: 'This is hole {hole}, par {par}.',
  voiceHcpOnHole: '{player}, {strokes} stroke handicap',
  ttsLang: 'en-US',
  editLogTitle: 'Edit Log',
  editLogHoleTitle: 'Hole {n} Edit Log',
  editLogEmpty: 'No edits recorded',
  editLogCount: '{n} edits',
  editLogAllRecorded: 'All edits are logged',
  editLogScore: 'Score',
  editLogPutts: 'Putts',
  editLogUp: 'UP',
  editNotifyTitle: 'Hole {n} score edited',
  editNotifyBy: 'Edited by {who}',
  editNotifyDetail: 'Tap to view details',
  editLogTapHint: 'Tap on hole number to view edit log',
  editLogClose: 'Close',
  // Viewer Mode
  mpRoleTitle: 'Join Room',
  mpRoleDesc: 'How would you like to join?',
  mpPlayerRole: 'Player',
  mpPlayerRoleDesc: 'Claim players and input scores',
  mpPlayerTagInput: 'Input scores',
  mpPlayerTagClaim: 'Claim players',
  mpViewerRole: 'Viewer',
  mpViewerRoleDesc: 'Watch the game live, read-only',
  mpViewerTagLive: 'Live scores',
  mpViewerTagNoInput: 'No input',
  mpViewerBanner: 'VIEW ONLY — score input disabled',
  mpViewerReminder: 'You are viewing this game',
  mpViewerReminderDesc: 'Scores update in real-time. You cannot input or modify scores.',
  exit: 'Exit',
  // Scorecard Section
  scorecardHorizontal: 'Horizontal',
  scorecardVertical: 'Vertical',
  shareBtn: 'Share',
  penalties: 'Penalties',
  // Feedback
  feedbackBtn: 'Give Feedback',
  feedbackTitle: 'Feedback',
  feedbackSubtitle: 'Help us improve HandinCap',
  feedbackRateLabel: 'Rate your experience',
  feedbackCatLabel: 'What would you like improved? (multi-select)',
  feedbackCatNewModes: 'More game modes',
  feedbackCatUI: 'UI / Layout',
  feedbackCatSpeed: 'Performance',
  feedbackCatCourse: 'Course data',
  feedbackCatScoring: 'Scoring',
  feedbackCatMultiplayer: 'Multiplayer',
  feedbackCatBug: 'Bug report',
  feedbackCatOther: 'Other',
  feedbackCommentPlaceholder: 'Tell us what you think...\ne.g. Would love Nassau mode',
  feedbackSubmit: 'Submit Feedback',
  feedbackSubmitting: 'Submitting...',
  feedbackThanks: 'Thank you!',
  feedbackThanksDetail: 'We read every piece of feedback',
  feedbackSkip: 'Maybe later',
  feedbackStar1: 'Poor',
  feedbackStar2: 'Fair',
  feedbackStar3: 'Good',
  feedbackStar4: 'Great',
  feedbackStar5: 'Amazing!',
  // Share page
  shareInvalidLink: 'Invalid Link',
  shareInvalidDesc: 'This share link is invalid or expired.',
  shareGoTo: 'Go to HandinCap',
  poweredBy: 'Powered by',
  onLabel: 'On',
  avg: 'Avg',
  totalLabel: 'Total',
  // Multiplayer extras
  mpConnectionStatus: 'Connection Status',
  mpPlayersJoined: 'Players joined',
  mpViewersJoined: 'Viewers joined',
  mpNoPlayersYet: "No players joined yet. You can still start — you'll score all players yourself.",
  mpProcessing: 'Processing...',
  mpClaimed: 'Claimed',
  mpNoPlayers: 'No players available',
  // Additional UI
  ob: 'OB',
  allConfirmed: 'All Confirmed',
  liveSyncing: 'Live syncing',
  justNow: 'just now',
  minsAgo: '{n}m ago',
  hrsAgo: '{n}h ago',
  roomNotFound: 'Room not found',
  // Round Report
  rrTitle: 'ROUND REPORT',
  rrGolfCourse: 'Golf Course',
  rrTotalScorePar: 'Total Score (Par: {n})',
  rrShareImage: 'Share Image',
  rrShareLink: 'Share Link',
  rrImageDownloaded: 'Image downloaded',
  rrImageFailed: 'Failed to generate image',
  rrScreenshotFailed: 'Screenshot failed, please take a manual screenshot',
  rrOpenApp: 'Open HandinCap',
  loading: 'Loading...',
};

export default en;